var moment = require("moment");

function toBoolean (value) {
	var isFalse = !value || String(value).toLowerCase() == 'false';
	return !isFalse;
}

function trySafe (unsafeCallback, args) {
	try {
		return unsafeCallback.apply(this, args);
	} catch (e) {
		console.error(e);
		return;
	}
}

function isNullOrUndefined (obj) {
	return obj === null || obj === undefined
}

$(document).ready(function () {
	var today = moment().format("DD.MM.YY");
	var firstDay = moment.localeData().firstDayOfWeek();
	var monthNames = (moment.monthsShort() || []).map(m => m.charAt(0).toUpperCase() + (m.endsWith('.') ? m.slice(1, -1) : m.slice(1)));
	var daysOfWeek = (moment.weekdaysMin() || []).map(d => String(d.charAt(0)).toUpperCase());
	var calendarOptions = {
		"autoApply": true,
		"singleDatePicker": true,
		"autoUpdateInput": false,
		"minDate": today,
		"startDate": today,
		"drops": "down"
	};
	calendarOptions.locale = calendarOptions.locale || {};
	calendarOptions.locale.daysOfWeek = daysOfWeek;
	calendarOptions.locale.monthNames = monthNames;
	calendarOptions.locale.firstDay = firstDay;
	calendarOptions.locale.format = 'DD.MM.YY';
	var singleCalendarOptions = JSON.parse(JSON.stringify(calendarOptions));

	function InvalidDateChecker (date, dateRange, blockoutDates) {
		var invalidDate = true; // Start looking for valid dates
		var format = "YYYY-MM-DD";

		date = moment(date); //clone and assure it's a moment object

		if (!isNullOrUndefined(dateRange)) {
			Array.isArray(dateRange) && dateRange.forEach(function (day) {
				var startDate = moment(day.start, format);
				var endDate = moment(day.end, format);

				if (date.isBetween(startDate, endDate, 'day') || date.isSame(startDate, 'day') || date.isSame(endDate, 'day')) {
					if (!day.availableWeekdays) {
						invalidDate = false;
					} else if (day.availableWeekdays && day.availableWeekdays.indexOf(date.format("dddd")) != -1) {
						invalidDate = false;
					}
				}
			});
		} else {
			invalidDate = false; // Start looking for invalid dates
		}

		if (!isNullOrUndefined(blockoutDates)) {
			Array.isArray(blockoutDates) && blockoutDates.forEach(function (day) {
				var startDate = moment(day.start, format);
				var endDate = moment(day.end, format);
				if (date.isBetween(startDate, endDate, 'day') || date.isSame(startDate, 'day') || date.isSame(endDate, 'day')) {
					invalidDate = true;
				}
			})
		}
		return invalidDate;
	}

	var dateRange, blockoutDates, blockoutNotStartDates;
	var getTourPriceUrl = $("#getTourPriceUrl").val();
	if (getTourPriceUrl && $(".booking--calendar").length > 0) {
		var params = {};
		var locationName = $("#locationName").val();
		var contentId = $("#contentId").val();
		if (locationName) {
			params.location = locationName;
		}
		if (contentId) {
			params.contentId = contentId;
		}

		//$.ajax = ajax_response(mockBooking, true);
		var jqxhr = $.ajax({
			url: getTourPriceUrl,
			headers: {
				'Cache-Control': 'no-cache,no-store,must-revalidate'
			},
			type: "GET",
			dataType: 'json',
			data: params,
			success: function (data) {
				dateRange = data.dateRange;
				blockoutDates = data.blockoutDates;
				blockoutNotStartDates = data.blockoutNotStartDates;
				if (data.minDate) { (calendarOptions.minDate = moment(data.minDate, "YYYY-MM-DD").format("DD.MM.YY")) }
				if (data.startDate) { (calendarOptions.startDate = moment(data.startDate, "YYYY-MM-DD").format("DD.MM.YY")) }
				window.isPreorder = String(data.preOrder) === 'true'

				calendarOptions.isInvalidDate = function (date) {
					return InvalidDateChecker(date, dateRange, blockoutDates);
				};

				calendarOptions.isCustomDate = function (date) {
					if (moment(date).isSameOrBefore(moment(), 'day')) {
						return "invalidDateFormat";
					}

					if (InvalidDateChecker(date, dateRange, null)) {
						return "invalidDateFormat";
					}

					if (InvalidDateChecker(date, null, blockoutDates)) {
						return ["fixOffCalendar"];
					}

					if (InvalidDateChecker(date, null, blockoutNotStartDates)) {
						return ["disabled", "fixOffCalendar"];
					}

					return false;
				};

				if (data.campaign && $(".special-offer-sm").length) {
					$(".special-offer-sm").removeClass("hidden");
				} else {
					$(".special-offer-sm").addClass("hidden");
				}
			},
			error: function (xhr) { }
		});

		jqxhr.always(function () {
			applyCalendar();
		})
	} else {
		applyCalendar();
	}
	function applyCalendar () {
		var getTourPriceUrl = $("#getTourPriceUrl").val();
		$(".booking--calendar").each(function () {
			var self = $(this);

			calendarOptions.parentEl = "#" + self.parents('div[id$="-inputs"]').eq(0).attr("id");

			if (calendarOptions.parentEl == "#stickybooking-inputs") {
				calendarOptions.drops = "up";
			}

			self.val('');
			var bookingStartDate = $("#bookingStartDate").val();
			var bookingEndDate = $("#bookingEndDate").val();
			if (bookingStartDate != undefined) {
				var tourDuration = parseInt($("#tourDuration").val()) || 1;
				var startDate = trySafe(function () { return moment(bookingStartDate, "YYYY-MM-DD"); });
				var endDate = trySafe(function () { return toBoolean(bookingEndDate) && startDate ? moment(bookingEndDate, "YYYY-MM-DD") : moment(startDate).add(tourDuration - 1, "days"); });
				calendarOptions.startDate = startDate && startDate.format("DD/MM/YY") || today;
				calendarOptions.endDate = endDate && endDate.format("DD/MM/YY") || today;
				trySafe(function () {
					// CAUTION: If changing this format you also have to change the parsing on booking.js on change event handler for (#bookingForm1 [data-booking-input]) around line 1060
					self.val(startDate.format("DD. MMMM YY") + " - " + endDate.format("DD. MMMM YY")).trigger('change');
				});
			}
			var bookingMinDate = $("#bookingMinDate").val();
			if (bookingMinDate != undefined) {
				var minDate = trySafe(function () { return moment(bookingMinDate, "YYYY-MM-DD"); });
				calendarOptions.minDate = minDate && minDate.format("DD/MM/YY") || today;
			}
			self.daterangepicker(calendarOptions);

			if (self.attr("id") != "forgotMyBookingDate") {
				self.attr("placeholder", "dd.mm.yy - dd.mm.yy");
			}

			self.off('apply.daterangepicker')
			self.on('apply.daterangepicker', function (ev, picker) {
				picker.startDate = !picker.startDate ? moment.invalid() : moment(picker.startDate.locale(moment.locale())); // Fixing startDate locale

				var tourDuration = parseInt($("#tourDuration").val());
				if (tourDuration > 1) {
					var endDate = moment(picker.startDate).add(tourDuration - 1, 'days');
				} else {
					var endDate = moment(picker.startDate);
				}
				picker.endDate = endDate;

				if (self.attr("id") == "forgotMyBookingDate") {
					self.val(picker.startDate.format('DD.MMM.YY')).trigger('change');
				} else {
					trySafe(function () {
						self.val(picker.startDate.format('DD. MMMM YY') + ' - ' + picker.endDate.format('DD. MMMM YY')).trigger('change');
					});
				}

				if (getTourPriceUrl && $("#pageFunctions").val() == "tour") {
					$("#loading-wrap").removeClass("hidden");
					$("#price-wrap").addClass("hidden");

					$.ajax({
						url: getTourPriceUrl,
						headers: {
							'Cache-Control': 'no-cache,no-store,must-revalidate'
						},
						type: "GET",
						dataType: 'json',
						data: {
							"location": $("#locationName").val(),
							"startDate": picker.startDate.format("YYYY-MM-DD"),
							"endDate": picker.endDate.format("YYYY-MM-DD"),
							"infants": $("#infants").val() || 0,
							"children": $("#children").val() || 0,
							"adults": $("#adults").val() || 2 //Set 2 adults as default price
						},
						success: function (data) {
							if (data.tourPrice) {
								var priceTourBooking = $("#priceTourBooking");
								priceTourBooking.text(data.tourPrice);
								priceTourBooking.html(data.tourPrice);
								priceTourBooking.attr('data-original-price-text', data.tourPrice);
								priceTourBooking.data('originalPriceText', data.tourPrice);
								var priceTourBookingWrapper = priceTourBooking.parent();

								window.isPreorder = String(data.preOrder) === 'true'

								// Global functions from js/authentic/exchangeCurrencies.js
								var exchangeRateCurrency = window.loadExchangeRateFromSession && window.loadExchangeRateFromSession();
								if (exchangeRateCurrency && priceTourBookingWrapper[0]) {
									window.switchExchangeRateCurrency(priceTourBookingWrapper[0], exchangeRateCurrency.from, exchangeRateCurrency.to, exchangeRateCurrency.rate);
								}

								$("#bookingStartDateVal").val(picker.startDate.format("YYYY-MM-DD")).trigger('change');
								$("#bookingEndDateVal").val(picker.endDate.format("YYYY-MM-DD")).trigger('change');

								$("#loading-wrap").addClass("hidden");
								$("#price-wrap").removeClass("hidden");
							}

							if (data.campaign && $(".special-offer-sm").length) {
								$(".special-offer-sm").removeClass("hidden");

								if (data.campaign.length
									&& $(".special-offer-sm > span") && $(".special-offer-sm > span").length) {
									$(".special-offer-sm > span").html(data.campaign);
								}

							} else {
								$(".special-offer-sm").addClass("hidden");
							}
						},
						error: function (xhr) {
							console.log("location: " + $("#locationName").val());
							console.log("startDate: " + picker.startDate.format("YYYY-MM-DD"));
							console.log("endDate: " + picker.endDate.format("YYYY-MM-DD"));
							console.log("infants: " + ($("#infants").val() || 0));
							console.log("children: " + ($("#children").val() || 0));
							console.log("adults: " + ($("#adults").val() || 2))
						}
					});

				} else if (getTourPriceUrl && $("#pageFunctions").val() == "experience") {

					$.ajax({
						url: getTourPriceUrl,
						headers: {
							'Cache-Control': 'no-cache,no-store,must-revalidate'
						},
						type: "GET",
						dataType: 'json',
						data: {
							"startDate": picker.startDate.format("YYYY-MM-DD"),
							"endDate": picker.endDate.format("YYYY-MM-DD"),
							"infants": $("#infants").val() || 0,
							"children": $("#children").val() || 0,
							"adults": $("#adults").val() || 2 //Set 2 adults as default price
						},
						success: function (data) {
							if (data.experiencePrice) {
								$("#priceTourBooking").text(data.experiencePrice);
								$("#priceUnitLabelTourBooking").text(data.unitLabel);
								$("#bookingStartDateVal").val(picker.startDate.format("YYYY-MM-DD")).trigger('change');
								$("#bookingEndDateVal").val(picker.endDate.format("YYYY-MM-DD")).trigger('change');
							}
						},
						error: function (xhr) {
							console.log("startDate: " + picker.startDate.format("YYYY-MM-DD"));
							console.log("endDate:" + picker.endDate.format("YYYY-MM-DD"));
							console.log("infants: " + ($("#infants").val() || 0));
							console.log("children: " + ($("#children").val() || 0));
							console.log("adults: " + ($("#adults").val() || 2))
						}
					});
					//$.ajax = ajaxOrig;
				}
			});

			if ($(window).width() < 768) {
				self.attr("readonly", "readonly");
			}
		});

		// Single date picker
		var defaultSingleDateFormat = 'DD/MM/YYYY';
		delete singleCalendarOptions.minDate;
		delete singleCalendarOptions.startDate;
		singleCalendarOptions.minYear = 1901;
		singleCalendarOptions.maxYear = parseInt(moment().format('YYYY'), 10);
		delete singleCalendarOptions.minYear;
		delete singleCalendarOptions.maxYear;
		singleCalendarOptions.locale.format = defaultSingleDateFormat;
		singleCalendarOptions.autoUpdateInput = false;
		singleCalendarOptions.singleDatePicker = true;
		singleCalendarOptions.showDropdowns = true;
		$(".single-date").each(function () {
			var self = $(this);
			var fieldFormat = self.data('format') || singleCalendarOptions.locale.format;
			var isBirthdayField = /_birthday$/.test(self.attr('id') || '');
			var startDate = String(self.data('start-date') || self.data('date') || self.data('datetime') || self.data('birthday') || '').trim();
			var minYear = parseInt(self.data('min-year'));
			var maxYear = parseInt(self.data('max-year'));

			function parseSingleDateValue (value, strict) {
				var normalizedValue = String(value || '').trim();
				var parsedValue = strict ? moment(normalizedValue, fieldFormat, true) : moment(normalizedValue, fieldFormat);
				return parsedValue.isValid() ? parsedValue : null;
			}

			singleCalendarOptions.locale.format = fieldFormat;

			if (minYear) {
				var defaultDate = '01/01/' + Math.max(minYear, 1950);
				singleCalendarOptions.startDate = startDate || defaultDate;
				singleCalendarOptions.minYear = minYear;
				singleCalendarOptions.minDate = '01/01/' + minYear;
			}
			if (maxYear) {
				singleCalendarOptions.maxYear = maxYear;
				singleCalendarOptions.maxDate = '31/12/' + maxYear;
			}
			if (startDate !== '' && startDate.toLowerCase() !== 'invalid date') {
				singleCalendarOptions.startDate = startDate;
			}
			var parentId = self.parent().attr('id');
			var selfId = self.attr('id');
			if (!parentId && selfId) {
				parentId = 'parent_' + selfId + '_parent';
				self.parent().attr('id', parentId);
			}
			singleCalendarOptions.parentEl = "#" + (parentId || self.parent().closest('[id]').attr('id'));

			// Apply today as minimum selectable date for the tour question travel date (no min/max year = not a birthday picker)

			self.daterangepicker(singleCalendarOptions);
			if (!minYear && !maxYear && self.closest('#tourQuestionForm').length) {
				var tqMinDateVal = $("#bookingMinDate").val();
				var tqMinDate = tqMinDateVal ? moment(tqMinDateVal, "YYYY-MM-DD") : moment();
				if (tqMinDate.isValid()) {
					singleCalendarOptions.minDate = tqMinDate.format(format);
					if (!startDate) {
						singleCalendarOptions.startDate = tqMinDate.format(format);
					}
				}
			}

			self.daterangepicker(singleCalendarOptions);

			var calendar = $(singleCalendarOptions.parentEl).find('.calendar.left.single');
			calendar.on('change', 'select.monthselect, select.yearselect', function () {
				var select = $(this);
				var mVal = parseSingleDateValue(self.val(), isBirthdayField);
				if (!mVal) {
					return;
				}
				if (select.hasClass('monthselect')) {
					mVal.month(select.val());
				} else if (select.hasClass('yearselect')) {
					mVal.year(select.val());
				}

				self.val(mVal.format(fieldFormat));
			});

			// Fix the month and year behavior, allowing the input to be immediately updated
			self.on('hide.daterangepicker', function (ev, picker) {
				picker.startDate = !picker.startDate ? moment.invalid() : moment(picker.startDate.locale(moment.locale())); // Fixing startDate locale
				var newVal = self.val();
				var startDate = picker.startDate.format(fieldFormat);
				var oldStartDate = picker.oldStartDate.format(fieldFormat);
				if (newVal && startDate !== newVal && oldStartDate === startDate) { //Check to prevent "apply event" and execution "onload"
					var parsedManualValue = parseSingleDateValue(newVal, isBirthdayField);
					if (!parsedManualValue) {
						newVal = '';
						self.val(newVal);
					} else {
						newVal = parsedManualValue.format(fieldFormat);
						self.val(newVal);
						picker.setStartDate(newVal);
						picker.setEndDate(newVal);
					}
					self.trigger('change');
				}
			});

			self.on('apply.daterangepicker', function (ev, picker) {
				picker.startDate = !picker.startDate ? moment.invalid() : moment(picker.startDate.locale(moment.locale())); // Fixing startDate locale
				var newVal = picker.startDate.format(fieldFormat);
				if (newVal === "Invalid date") {
					newVal = '';
				}
				self.val(newVal);
				self.trigger('change');
			});
			if ($(window).width() < 768) {
				self.attr("readonly", "readonly");
			}
		});
	}
});



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/calendar.js